import { Box, Typography } from "@mui/material";
import { BorderedInputField } from "components/UI";
import { ErrorMessage } from "components/UI/ErrorMessage";
import { isEmpty } from "lodash";
import { memo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const StructureDescriptionSection = memo(
  ({ control, errors, mutationError }) => {
    const { t } = useTranslation();

    return (
      <Box>
        <Typography
          component="label"
          htmlFor="description"
          variant="h6"
          sx={{ mb: 1 }}
        >
          {t("denominations.structures.structureDescription")}
        </Typography>
        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <BorderedInputField
              id="description"
              size="small"
              autoComplete="off"
              multiline
              minRows={4}
              fullWidth
              inputProps={{
                maxLength: 200
              }}
              {...field}
              error={
                !!errors.description?.message ||
                !isEmpty(mutationError?.errors?.description)
              }
              helperText={
                `${field.value?.length || 0}/200` ||
                errors.description?.message || (
                  <ErrorMessage messages={mutationError?.errors?.description} />
                )
              }
            />
          )}
        />
      </Box>
    );
  }
);

StructureDescriptionSection.displayName = "StructureDescriptionSection";

export default StructureDescriptionSection;
